import { Alert } from "@mui/material";
import PropTypes from "prop-types";
import { useAtomValue } from "jotai";
import { maintenanceNoticeAtom } from "@accredo/fe-shared/atoms/maintenanceNoticeAtom.js";

const MaintenanceNotice = ({ sx }) => {
  const notice = useAtomValue(maintenanceNoticeAtom);

  if (!notice) {
    return null;
  }

  return (
    <Alert severity="warning" sx={sx}>
      {notice}
    </Alert>
  );
};

MaintenanceNotice.propTypes = {
  sx: PropTypes.object,
};

export default MaintenanceNotice;
